// ======== REVELAR ELEMENTOS SUAVEMENTE AL HACER SCROLL ========
// Espera a que cargue el DOM
document.addEventListener('DOMContentLoaded', () => {
  // Selecciona secciones y elementos principales
 const elements = document.querySelectorAll(
  '.section:not(.shopify-section-header):not(.announcement-bar-section), .card, .product-card, .image-with-text, .banner, .media, .grid__item:not(footer .grid__item)'
);


  // Añade la clase "reveal" a cada uno (para iniciar ocultos)
  elements.forEach(el => el.classList.add('reveal'));

  // Usa IntersectionObserver para mostrarlos cuando entren al viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 }); // se activa cuando el 14% del elemento es visible

  // Observa todos los elementos seleccionados
  elements.forEach(el => observer.observe(el));
});
